const snackBarTypes = {
  SUCCESS: 'SUCCESS',
  FAIL: 'FAIL',
  NEUTRAL: 'NEUTRAL',
};

export default snackBarTypes;
